module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n  <p>You have no pending imports.</p>\n</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./epayment_import/templates/no_pending.html
// module id = 212
// module chunks = 0